import { Stack, Typography, Box, useTheme } from '@mui/material';

import VectorImage from '~components/media/vectorImage';
import { Dimens } from '~themes';

interface Props {
	fileName: string;
	fileSize: string;
	label?: string;
	downloadable?: boolean;
	fileType?: 'xlsx' | 'csv' | 'pdf' | 'pfx' | 'pem' | 'other';
	onDownloadClicked?: () => void;
}

const FileCard = ({
	fileName,
	fileSize,
	label,
	fileType = 'other',
	downloadable = true,
	onDownloadClicked,
}: Props) => {
	const { palette } = useTheme();
	const iconSize = Dimens.spacing6xl;
	return (
		<Stack gap={Dimens.spacingMd}>
			{label && (
				<Typography variant='labelSm' color='textSecondary'>
					{label}
				</Typography>
			)}
			<Box
				sx={{
					paddingX: Dimens.spacingXl,
					paddingY: Dimens.spacingLg,
					border: `1px solid ${palette.borderPrimary.main}`,
					borderRadius: Dimens.radiusXs,
				}}
			>
				<Stack direction='row' alignItems={'center'} spacing={Dimens.spacingSm}>
					{(() => {
						switch (fileType) {
							case 'pdf':
								return <VectorImage name='filetype/pdf' size={iconSize} original />;
							case 'xlsx':
								return <VectorImage name='filetype/excel' size={iconSize} original />;
							case 'csv':
								return <VectorImage name='filetype/csv' size={iconSize} original />;
							case 'pfx':
								return <VectorImage name='filetype/pfx' size={iconSize} original />;
							case 'pem':
								return <VectorImage name='filetype/pem' size={iconSize} original />;
						}
					})()}

					<Stack direction='column' sx={{ flex: 1 }} spacing={Dimens.spacingXs}>
						<Typography variant='labelSm' color='textPrimary'>
							{fileName}
						</Typography>
						<Typography variant='labelXs' color='textQuaternary'>
							{fileSize}
						</Typography>
					</Stack>
					{downloadable && (
						<Box sx={{ cursor: 'pointer' }} onClick={onDownloadClicked}>
							<VectorImage name='icon/download' size={20} />
						</Box>
					)}
				</Stack>
			</Box>
		</Stack>
	);
};

export default FileCard;
